import styled from '@emotion/styled'

import { spacing } from 'main/ui'

export const imageSize = 68

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 120px;
`

export const ImageContainer = styled.div`
  height: ${imageSize}px;
  margin-bottom: ${spacing.majorScale(1)}px;
  width: ${imageSize}px;
`
